export function setAccordion(data) {
  return {
    type: 'SET_ACCORDION',
    payload: data,
  };
};
